import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { UserRole } from 'data/terra/UserRole';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { CommonState } from '../reducer';

export const FETCH_USER_ROLES = 'FETCH_USER_ROLES';

export interface FetchUserRolesAction {
  type: typeof FETCH_USER_ROLES;
  userRoles: UserRole[];
}

export const fetchUserRoles = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async dispatch => {
  const result = await Terra.user.fetchUserRoles();
  if (result.isSuccess()) {
    dispatch({
      type: FETCH_USER_ROLES,
      userRoles: result.get()!.data,
    } as FetchUserRolesAction);
  }

  return result;
};

export const fetchUserRolesDelegate: DelegateMapEntry<
  FetchUserRolesAction,
  CommonState
> = {
  [FETCH_USER_ROLES]: (
    state: CommonState,
    action: FetchUserRolesAction
  ): CommonState => {
    return {
      ...state,
      userRoles: action.userRoles,
    };
  },
};
